// src/hooks/useUserProfile.ts
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { UserService } from '../admin/pages/users/userService';

export const USER_PROFILE_KEYS = {
  claims: (uid: string) => ['userProfile', 'claims', uid] as const,
};

export const useUserClaims = (uid: string | undefined) => {
  return useQuery({
    queryKey: USER_PROFILE_KEYS.claims(uid ?? ''),
    queryFn: () => UserService.getUserClaims(uid!),
    enabled: !!uid,
    staleTime: 1000 * 60 * 5, // 5 min — role rarely changes mid-session
    retry: (failureCount, error: any) => {
      if (error?.code === 'permission-denied') return false;
      return failureCount < 1;
    },
  });
};

// Call this after a profile save to bust the claims cache
export const useInvalidateUserClaims = () => {
  const queryClient = useQueryClient();
  return (uid: string) => {
    queryClient.invalidateQueries({ queryKey: USER_PROFILE_KEYS.claims(uid) });
  };
};